<div class="col-12 home-panel mt-2" style="font-size: 16px;">
    <div class="terms-panel mt-2"    
        [innerHTML]="achdInfo">
    </div>        
    <div class="text-center mt-2"><button class="btn btn-primary" (click)="goToACHDebitLanding()">{{homeButtonText}}</button></div>    
</div>  